import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import AurSvgIcon from '../aur-svg-icon/AurSvgIcon';
import { useEffect } from 'react';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { GA_DATA_MODE_AUTO, GA_ERROR_CODES, GA_ERROR_TYPES, GA_EVENT_NAMES } from '../../../constants/analyticsConstants';

/*
Component for displaying the data of 404 Error page
*/
const AurPageNotFound = () => {
  const {trackGAEvent} = useAnalytics();

  useEffect(() => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.ERROR,
      page: GA_DATA_MODE_AUTO,
      user: GA_DATA_MODE_AUTO,
      error: {
        type: GA_ERROR_TYPES.PAGE_NOT_FOUND,
        text: t('errors.notFound.title') + ' ' + t('errors.notFound.description'),
        code: GA_ERROR_CODES.NOT_FOUND_404,
      },
    });
  }, []);
  return (
    <Box className="page-not-found-container">
      <Box className="sub-container">
        <AurSvgIcon src="images/page_not_found.svg" />
        <Typography className="typo-text display2_size mist-color-100 permission-error-title">
          {t('errors.notFound.title')}
        </Typography>
        <Typography className="typo-text subhead3_size mist-color-400 permission-error-desc">
          {t('errors.notFound.description')}
        </Typography>
        <Typography className="typo-text subhead5_size mist-color-900">
          {t('errors.notFound.linkErrorCode')}
        </Typography>
      </Box>
    </Box>
  );
};

export default AurPageNotFound;
